import RpmList from './RpmList';

export default RpmList;